export const environment = {
    production: false,

    APICOMMON_URL: 'https://mccarthyapi.eliancedemo.co.za/common/',
    SUPPLIERONBOARDING_API_URL: 'https://supplieronboarding.eliancedemo.co.za/api/', //supplier onboarding api
    API_URL: '',
    API_KEY:
        '57fe20bc23f634ce10bb5b290b96841dd388d0865294e5c696fad17c03f98e94b179df6e5c7cd4827fa3e534441aa5d56412fea1e114adc315932d6ccfe22daf',
    APP_ID: 'MCSO',
};
